// extracted by mini-css-extract-plugin
export default {"container":"style_container__RRC6E","center":"style_center__lfUm6","card":"style_card__Eea6h","title":"style_title__UluAn","description":"style_description__oA2Ys"};